import { BrowserRouter, Route, Routes } from 'react-router-dom';
import './App.css';
import './index.css';
import Home from './Pages/Home';
import About from './Pages/About';
import Services from './Pages/Services';
import Projects from './Pages/Projects';
import Contact from './Pages/Contact';
import PageHeader from './Pages/PageHeader';

function App() {
  return (
    <div className="App">
     <BrowserRouter>
      <Routes>
        
        <Route path='/' element={<Home />} />
        <Route path='/pageheader' element={<PageHeader />} />
        <Route path='/about' element={<About />} />
        <Route path='/services' element={<Services />} />
        <Route path='/projects' element={<Projects />} />
        <Route path='/contact' element={< Contact />} />
       
        
      </Routes>
     </BrowserRouter>
      </div>
  );
}

export default App;
